export enum MarketFiltersFields {
  ordering = 'ordering',
  category = 'category',
  statuses = 'statuses',
  priceRange = 'priceRange',
  revenuePeriod = 'revenuePeriod',
  search = 'search',
}
